import { SkeletonLoader, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div<{
  $isRead?: boolean;
  $isHighlighted?: boolean;
}>`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px;
  border-radius: 8px;
  background: var(--background-soft);
  cursor: pointer;
  box-sizing: border-box;
  &:hover {
    background-color: var(--surface-hover);
  }
`;

export const FlexWrapper = styled.div`
  display: flex;
  gap: 12px;
  min-width: 0;
`;

export const Content = styled.div`
  width: 100%;
  min-width: 0;
  flex: 1;
`;

export const HeaderWrapper = styled.div<{ $isRead?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
  min-width: 0;
`;

export const CardTitle = styled.div<{
  $isRead?: boolean;
}>`
  ${typographyV2.bodySm};
  overflow: hidden;
  color: ${({ $isRead }) =>
    $isRead ? 'var(--text-soft)' : 'var(--text-default)'};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DateLabel = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const CardDescription = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const Description = styled.div`
  display: flex;
  gap: 8px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
`;

export const GreyDot = styled.span`
  width: 2px;
  height: 2px;
  border-radius: 50%;
  display: inline-block;
  background-color: var(--icon-soft);
`;

export const CardType = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
  white-space: nowrap;
`;

export const TickerLabel = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const StyledLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '100px',
        borderRadius: '8px',
      },
    },
  ],
})``;
